import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useState } from 'react';

import Dialog from '~components/Dialog/Dialog';
import DialogContent from '~components/Dialog/DialogContent';
import DialogHeader from '~components/Dialog/DialogHeader';
import { TICKET_PDF_MIME_TYPE } from '~pages/Settings/DeletedRecords/constants';
import { Nullable } from '~types/Nullable';
import { ATTACHMENT_IMAGE_CROSS_ORIGIN } from '~utils/image/attachmentImageCrossOrigin';

interface DeletedTicketImageDialogProps {
  imageAlt: string;
  imageMimeType: Nullable<string>;
  imageUrl: string;
  isOpen: boolean;
  onClose: () => void;
  ticketNumber: string | null;
}

export default function DeletedTicketImageDialog({
  imageAlt,
  imageMimeType,
  imageUrl,
  isOpen,
  onClose,
  ticketNumber,
}: DeletedTicketImageDialogProps) {
  const [hasFailedToLoad, setHasFailedToLoad] = useState(false);

  return (
    <Dialog isOpen={isOpen} maxWidth="md" onClose={onClose}>
      <DialogHeader onClose={onClose}>
        {ticketNumber
          ? t('settings.deleted_records.ticket_image_title', { ticket: ticketNumber })
          : t('settings.deleted_records.ticket_image_title_unnumbered')}
      </DialogHeader>

      <DialogContent>
        {imageMimeType === TICKET_PDF_MIME_TYPE ? (
          <Box
            component="iframe"
            src={imageUrl}
            title={imageAlt}
            sx={{ border: 'none', height: '100%', minHeight: 480, width: '100%' }}
          />
        ) : hasFailedToLoad ? (
          <Typography sx={{ color: 'text.secondary', py: 4, textAlign: 'center' }}>
            {t('settings.deleted_records.ticket_image_failed')}
          </Typography>
        ) : (
          <Box
            component="img"
            alt={imageAlt}
            crossOrigin={ATTACHMENT_IMAGE_CROSS_ORIGIN}
            src={imageUrl}
            onError={() => setHasFailedToLoad(true)}
            sx={{ display: 'block', height: 'auto', maxWidth: '100%' }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
